// One stacking order for everything that floats during a call (CU-869fmcc9r). The pill and
// the dialer sit above MUI's normal layers (snackbar = 1400), so anything they open must sit
// above them too: a desk picker or Call back dialog on MUI's default modal layer (1300)
// rendered underneath and couldn't be clicked.
//   dialer button  snackbar - 1   (1399)
//   call pill      snackbar + 1   (1401)
//   dialer panel   snackbar + 2   (1402)  above the pill: the pill's default spot is beside it
//   call dialog    snackbar + 3   (1403)  desk picker, desk clash, handset fallback, call flow
//   call popup     snackbar + 4   (1404)  menus and dropdowns opened from any of the above
export const CALL_LAYER = Object.freeze({
    DIALER_BUTTON: -1,
    PILL: 1,
    DIALER: 2,
    DIALOG: 3,
    POPUP: 4,
});

// zIndex for an sx prop: `sx={{ zIndex: callLayer('DIALOG') }}`.
export const callLayer = (name) => (theme) => (theme?.zIndex?.snackbar ?? 1400) + CALL_LAYER[name];
